import { render, staticRenderFns } from "./ProfilPerusahaan.vue?vue&type=template&id=60856fc2&scoped=true&"
import script from "./ProfilPerusahaan.vue?vue&type=script&lang=js&"
export * from "./ProfilPerusahaan.vue?vue&type=script&lang=js&"
import style0 from "./ProfilPerusahaan.vue?vue&type=style&index=0&id=60856fc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60856fc2",
  null
  
)

export default component.exports